import React from "react";
import Box from "@mui/material/Box";
import { CountryInput } from "../../../../../../components/filters/Locations/CountryInput";

interface GeographyFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
}

export const GeographyFilter: React.FC<GeographyFilterProps> = ({
  value,
  onChange,
}) => {
  return (
    <Box id="install-geography-filter" sx={{ mb: 1 }}>
      <CountryInput
        selectedItems={value}
        onCountrySelect={onChange}
        placeholderText="Select countries..."
      />
    </Box>
  );
};
